import { render } from "./Projects.vue?vue&type=template&id=26c03d0c&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=26c03d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c03d0c"]])

export default __exports__